export default __webpack_public_path__ + "static/media/shopping.d87a9f71.png";